import React from 'react'
import Feature from 'components/Feature'
import { VictoryGroup, VictoryArea } from 'victory'
import { withTheme, color } from 'stylist'
import victoryTheme from 'config/victoryTheme'
import styled from 'react-emotion'

const PositionBrush = styled.div`
  width: 2px;
  height: 90%;
  bottom: 10%;
  position: absolute;
  left: ${({ percent }) => percent}%;
  background-color: ${color('slate')};
`

const GraphContainer = styled.div`
  position: relative;
`

const ImportanceGraph = ({
  theme,
  video: { highlightTrends },
  duration,
  currentTime
}) => (
  <Feature
    name="importance_graph"
    render={() =>
      highlightTrends ? (
        <div>
          <h6>Relative Importance</h6>
          <svg height={0}>
            <defs>
              <linearGradient
                id="importanceGradient"
                x1="0%"
                y1="0%"
                x2="0%"
                y2="100%"
              >
                <stop offset="0%" stopColor="rgba(0, 212, 232, 0.75)" />
                <stop offset="100%" stopColor="rgba(0, 199, 83, 0.1)" />
              </linearGradient>
            </defs>
          </svg>
          <GraphContainer>
            <VictoryGroup theme={victoryTheme} padding={0} height={30}>
              <VictoryArea
                style={{
                  data: {
                    fill: 'url(#importanceGradient)',
                    stroke: '#008594'
                  }
                }}
                data={highlightTrends.map(
                  ({ polarity, startTime, endTime }) => ({
                    x: (endTime - startTime) / 2 + startTime,
                    y: polarity + 1
                  })
                )}
              />
            </VictoryGroup>
            <PositionBrush percent={(currentTime / duration) * 100} />
          </GraphContainer>
        </div>
      ) : null
    }
  />
)

export default withTheme(ImportanceGraph)



// WEBPACK FOOTER //
// ./src/components/ImportanceGraph.js